import React from 'react';
import { Box, Typography } from '@mui/material';

const sections = [
  {
    title: 'Definition of Cookie',
    text: 'A cookie is a small file, comprised of messages and numbers which are on Data Subject\'s web browser. The cookie\'s purpose is to collect details of data, record of internet usage or interaction from visiting the website of the Data Subject. Cookie will help the Data Subject receive a greater experience surfing through the website, and assist the Company in furthering the development of the website\'s quality.',
  },
  {
    title: 'Type of Cookies',
    intro: 'Type of cookies that the Company uses are included but not limited to the list set out hereunder.',
    subsections: [
      {
        subtitle: '2.1 Strictly Necessary Cookie',
        text: 'Strictly Necessary Cookie hold a substantial significance to the functionality of the website, which also include the cookie that will enable Data Subject access to data and assure security in surfing through the Company\'s website.',
      },
      {
        subtitle: '2.2 Analytical/Performance Cookie',
        text: 'Analytical/Performance Cookie will assist the Company to recognize and count the amount of website traffic, as well as, assist the Company in understanding interactions from the website visits, in order to improve the website leading to higher quality and more suitable performance. Moreover, of the cookie will collect the statistical data regarding the website\'s way of access and visit interaction, which will improve the website\'s performance for the Data Subject to search for what they are looking for more easily and to assist the Company in comprehending website visitor\'s interests and evaluate the efficiency of the Company\'s advertisements.',
      },
      {
        subtitle: '2.3 Functionality Cookie',
        text: 'Functionality Cookie serves to recognize the Data Subject, when the Data Subject return to the website, it will assist the Company to be able to customize the Company\'s website content for the Data Subject, including recognize settings of the Data Subject, for example, language, region or letters font size used in the website.',
      },
    ],
    footer: 'Please note that some type of cookies on the website are operated by third parties, for example, advertising network\'s working aspect such as video, map and social media, and other outsource services, for example, analytic services of website visit, etc. These cookies are often Analytical/Performance cookies. The Data Subject shall pursue the cookie policy and the personal data policy in third party\'s website for the understanding data usage of the third parties.',
  },
  {
    title: 'Cookies Collection Period',
    intro: 'Cookies collection period shall be divided into 2 categories as follows:',
    subsections: [
      {
        subtitle: 'Session Cookies',
        text: 'Session Cookies will be automatically deleted when closing the browser.',
      },
      {
        subtitle: 'Persistent Cookies',
        text: 'Persistent Cookies will remain on the computer of Data Subject until expiration or deleted. Persistent Cookies can collect data of the Data Subject\'s interests in such a way that succeeding usage of the website of the Data Subject becomes easier and align more with the Data Subject\'s interests.',
      },
    ],
  },
  {
    title: 'Purpose of Cookies',
    items: [
      'To analyze the interests of the Data Subject, for the Company to be able to adjust service pattern, especially design, analytical mechanism process and other testing for the purpose of better responding to demands and interests of Data Subject.',
      'To track interactions of the Data Subject, for example, interactions with websites, applications or social media platform. To analyse the usage of websites, applications or social media platforms of Data Subject and to comprehend in the usage of the Data Subject find appealing. To make the websites, applications or social media platforms become more appropriate to the Data Subject, for example, the suggestions of products and services relevant, and advertisement on websites, applications and other channel accordingly to target group.',
    ],
  },
  {
    title: 'Setting of Cookies',
    text: 'Although the usage of cookie benefits in improving efficiency of the services and the performance of the website for the Data Subject, if the Data Subject disapprove of such benefits, the Data Subject can delete cookie settings on its own browser. Notwithstanding, the Data Subject acknowledges that by proceeding as such may affect the efficiency in some part of the website\'s performance according to the purpose of each type of cookie.',
  },
  {
    title: 'Amendments',
    text: 'The Company reserves all right in amending, modifying or adjusting measure concerning personal data protection to be more suitable under the enforcement of the Personal Data Protection law. In the event of any amendments, the Company shall notify you of the updated measures via email.',
  },
];

const CookiePolicy: React.FC = () => {
  return (
    <Box sx={{ mx: 'auto', mt: 4, mr: { xs: 0, md: 50 } }}>
      <Typography variant="h3" align="center" sx={{ mb: 6, fontFamily: 'Nandia' }}>
        Setting
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>
        Cookie Policy
      </Typography>

      <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.8, mb: 4 }}>
        IRIS 2005 CO., LTD. (the "Company") is strongly aware of an importance of rights and privacy of website's visitors ("Data Subject"). Therefore, the Company provides this Cookie Policy for the purpose of informing the Data Subject regarding collection, usage and disclosure (the "Processing") under the cookie management of the Company.
      </Typography>

      {sections.map((section, i) => (
        <Box key={i} sx={{ mb: 4 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
            {section.title}
          </Typography>

          {section.intro && (
            <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.8, mb: 1.5 }}>
              {section.intro}
            </Typography>
          )}

          {section.text && (
            <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.8 }}>
              {section.text}
            </Typography>
          )}

          {section.items && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pl: 2 }}>
              {section.items.map((item, j) => (
                <Typography key={j} variant="body2" sx={{ color: '#333', lineHeight: 1.8 }}>
                  • {item}
                </Typography>
              ))}
            </Box>
          )}

          {section.subsections && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pl: 2 }}>
              {section.subsections.map((sub, j) => (
                <Box key={j}>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: '#333', mb: 0.5 }}>
                    {sub.subtitle}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.8 }}>
                    {sub.text}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}

          {section.footer && (
            <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.8, mt: 1.5 }}>
              {section.footer}
            </Typography>
          )}
        </Box>
      ))}

      <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.8, mt: 2 }}>
        For further inquiries on details regarding the Company personal data processing, please kindly refer to the{' '}
        <Typography component="span" variant="body2" sx={{ fontWeight: 700, textDecoration: 'underline', cursor: 'pointer' }}
          onClick={() => window.location.href = '/privacy'}>
          Privacy Policy
        </Typography>
      </Typography>
    </Box>
  );
};

export default CookiePolicy;
